/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramCurrenciesControllerFindManyQueryResponse } from '../types/TelegramCurrenciesControllerFindMany.ts';

function getTelegramCurrenciesFindManyUrl() {
  const res = { method: 'GET', url: `/api/telegram/currencies` as const };
  return res;
}

/**
 * {@link /api/telegram/currencies}
 */
export async function telegramCurrenciesFindMany(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramCurrenciesControllerFindManyQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramCurrenciesFindManyUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
